import React from "react";
import Menu from "@material-ui/core/Menu";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";

import './styles.scss';

import {Ripple} from "../../../../helpers/Buttons/";
import Caret from "../Caret";

export default ({id, className, btnProps = {}, children, anchorOrigin = {}, transformOrigin = {}, PaperProps = {}, itemsList = [], fullWidth, hideCaret}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const classNames = ['merchant-dropdown', className, anchorEl && 'open'].join(' ');
  const btnID = `${id}-button`;
  const menuID = `${id}-menu`;

  return (
    <>
      <Ripple
        id={btnID}
        className={classNames}

        {...btnProps}

        aria-controls={open ? menuID : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {children}
        {!hideCaret && (
          <Caret />
        )}
      </Ripple>
      <Menu
        id={menuID}
        className="merchant-dropdown__subitems"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          ...anchorOrigin
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
          ...transformOrigin
        }}
        getContentAnchorEl={null}
        PaperProps={PaperProps}
        MenuListProps={{
          'aria-labelledby': btnID,
          'style': fullWidth ? {width: anchorEl && anchorEl.offsetWidth} : {}
        }}
      >
        {itemsList.map((el, i) => el.divider
          ? (
            <Divider key={i} />
          ) : (
            <MenuItem key={i} onClick={handleClose}>{el}</MenuItem>
          )
        )}
      </Menu>
    </>
  )
}
